import { useTranslation } from 'react-i18next'
import styles from './AccreditationGrid.module.scss'

const KPI_DEFS = [
  { key: 'student_teacher_ratio', labelKey: 'reports.kpi_student_teacher_ratio', unit: '', target: 12, kind: 'absolute', betterLow: true },
  { key: 'phd_ratio_in_faculty', labelKey: 'reports.kpi_phd_ratio', unit: '%', target: 0.4, kind: 'ratio' },
  { key: 'graduation_rate', labelKey: 'reports.kpi_graduation_rate', unit: '%', target: 0.85, kind: 'ratio' },
  { key: 'employment_rate_after_grad', labelKey: 'reports.kpi_employment_rate', unit: '%', target: 0.7, kind: 'ratio' },
  { key: 'competency_coverage_avg', labelKey: 'reports.kpi_competency_coverage', unit: '%', target: 0.8, kind: 'ratio' },
  { key: 'library_volumes_per_student', labelKey: 'reports.kpi_library_per_student', unit: 'шт.', target: 10, kind: 'absolute' },
  { key: 'international_student_ratio', labelKey: 'reports.kpi_international_share', unit: '%', target: 0.03, kind: 'ratio' },
  { key: 'publications_per_faculty_year', labelKey: 'reports.kpi_publications_per_faculty', unit: 'шт.', target: 1.5, kind: 'absolute' },
  { key: 'scholarship_recipients_ratio', labelKey: 'reports.kpi_scholarship_share', unit: '%', target: 0.15, kind: 'ratio' },
  { key: 'online_courses_ratio', labelKey: 'reports.kpi_online_courses_share', unit: '%', target: 0.1, kind: 'ratio' },
]

const formatVal = (val, def) => {
  if (val == null || Number.isNaN(Number(val))) return '—'
  const n = Number(val)
  if (def.kind === 'ratio') return `${(n * 100).toFixed(1)}%`
  if (def.unit === '%') return `${n.toFixed(1)}%`
  if (def.unit) return `${n.toLocaleString('ru-RU')} ${def.unit}`
  return n.toLocaleString('ru-RU')
}

const isHit = (val, def) => {
  if (val == null) return false
  const n = Number(val)
  if (Number.isNaN(n)) return false
  if (def.betterLow) return n <= def.target
  return n >= def.target
}

const formatTarget = (def) => {
  if (def.kind === 'ratio') return `≥ ${(def.target * 100).toFixed(0)}%`
  if (def.betterLow) return `≤ ${def.target}`
  return `≥ ${def.target}`
}

const AccreditationGrid = ({ data }) => {
  const { t } = useTranslation('common')
  const kpis = data?.kpis || {}

  return (
    <div className={styles.grid}>
      {KPI_DEFS.map((def) => {
        const val = kpis[def.key]
        const hit = isHit(val, def)
        return (
          <div key={def.key} className={`unv-card ${styles.card}`}>
            <div className={styles.label}>{t(def.labelKey)}</div>
            <div className={styles.value}>{formatVal(val, def)}</div>
            <div className={`${styles.ribbon} ${hit ? styles.ok : styles.miss}`}>
              <span>{t('reports.target_label', { target: formatTarget(def) })}</span>
              <span>{hit ? t('reports.target_met') : t('reports.target_missed')}</span>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default AccreditationGrid
